module.exports = __webpack_public_path__ + "static/mohammadi-53619e53a419b008e554d806c4d7c112.png";